import { getTermValue } from './helpers';
import { EInfrastructure, type NonEmptyArray, type TJsonQuery } from './types';
import { nonEmptyArrayOr } from './utils/nonEmptyArrayOr';

export function getInfrastructureTypes(jsonQuery: TJsonQuery): NonEmptyArray<EInfrastructure> | null {
  const hasCarWash = getTermValue('infrastructure_has_car_wash')(jsonQuery);
  const hasCarService = getTermValue('infrastructure_has_car_service')(jsonQuery);
  const hasPharmacy = getTermValue('infrastructure_has_pharmacy')(jsonQuery);
  const hasClothesStudio = getTermValue('infrastructure_has_clothes_studio')(jsonQuery);
  const hasAtm = getTermValue('infrastructure_has_atm')(jsonQuery);
  const hasPool = getTermValue('infrastructure_has_pool')(jsonQuery);
  const hasBuffet = getTermValue('infrastructure_has_buffet')(jsonQuery);
  const hasWarehouseComplex = getTermValue('infrastructure_has_exhibition_and_warehouse_complex')(jsonQuery);
  const hasHotel = getTermValue('infrastructure_has_hotel')(jsonQuery);
  const hasCafe = getTermValue('infrastructure_has_cafe')(jsonQuery);
  const hasCinema = getTermValue('infrastructure_has_cinema')(jsonQuery);
  const hasConferenceRoom = getTermValue('infrastructure_has_conference_room')(jsonQuery);
  const hasMedicalCenter = getTermValue('infrastructure_has_medical_center')(jsonQuery);
  const hasMinimarket = getTermValue('infrastructure_has_minimarket')(jsonQuery);
  const hasNotaryOffice = getTermValue('infrastructure_has_notary_office')(jsonQuery);
  const hasBankDepartment = getTermValue('infrastructure_has_bank_department')(jsonQuery);
  const hasPark = getTermValue('infrastructure_has_park')(jsonQuery);
  const hasRestaurant = getTermValue('infrastructure_has_restaurant')(jsonQuery);
  const hasBeautyShop = getTermValue('infrastructure_has_beauty_shop')(jsonQuery);
  const hasWarehouse = getTermValue('infrastructure_has_warehouse')(jsonQuery);
  const hasCanteen = getTermValue('infrastructure_has_canteen')(jsonQuery);
  const hasSupermarket = getTermValue('infrastructure_has_supermarket')(jsonQuery);
  const hasShoppingArea = getTermValue('infrastructure_has_shopping_area')(jsonQuery);
  const hasFitnessCentre = getTermValue('infrastructure_has_fitness_centre')(jsonQuery);
  const hasStudio = getTermValue('infrastructure_has_studio')(jsonQuery);
  const hasCentralReception = getTermValue('infrastructure_has_central_reception')(jsonQuery);

  const infrastructureTypes: EInfrastructure[] = [];

  if (hasCarWash) {
    infrastructureTypes.push(EInfrastructure.CarWash);
  }

  if (hasCarService) {
    infrastructureTypes.push(EInfrastructure.CarService);
  }

  if (hasPharmacy) {
    infrastructureTypes.push(EInfrastructure.Pharmacy);
  }

  if (hasClothesStudio) {
    infrastructureTypes.push(EInfrastructure.ClothesStudio);
  }

  if (hasAtm) {
    infrastructureTypes.push(EInfrastructure.ATM);
  }

  if (hasPool) {
    infrastructureTypes.push(EInfrastructure.Pool);
  }

  if (hasBuffet) {
    infrastructureTypes.push(EInfrastructure.Buffet);
  }

  if (hasWarehouseComplex) {
    infrastructureTypes.push(EInfrastructure.WarehouseComplex);
  }

  if (hasHotel) {
    infrastructureTypes.push(EInfrastructure.Hotel);
  }

  if (hasCafe) {
    infrastructureTypes.push(EInfrastructure.Cafe);
  }

  if (hasCinema) {
    infrastructureTypes.push(EInfrastructure.Cinema);
  }

  if (hasConferenceRoom) {
    infrastructureTypes.push(EInfrastructure.ConferenceRoom);
  }

  if (hasMedicalCenter) {
    infrastructureTypes.push(EInfrastructure.MedicalCenter);
  }

  if (hasMinimarket) {
    infrastructureTypes.push(EInfrastructure.Minimarket);
  }

  if (hasNotaryOffice) {
    infrastructureTypes.push(EInfrastructure.NotaryOffice);
  }

  if (hasBankDepartment) {
    infrastructureTypes.push(EInfrastructure.BankDepartment);
  }

  if (hasPark) {
    infrastructureTypes.push(EInfrastructure.Park);
  }

  if (hasRestaurant) {
    infrastructureTypes.push(EInfrastructure.Restaurant);
  }

  if (hasBeautyShop) {
    infrastructureTypes.push(EInfrastructure.BeautyShop);
  }

  if (hasWarehouse) {
    infrastructureTypes.push(EInfrastructure.Warehouse);
  }

  if (hasCanteen) {
    infrastructureTypes.push(EInfrastructure.Canteen);
  }

  if (hasSupermarket) {
    infrastructureTypes.push(EInfrastructure.Supermarket);
  }

  if (hasShoppingArea) {
    infrastructureTypes.push(EInfrastructure.ShoppingArea);
  }

  if (hasFitnessCentre) {
    infrastructureTypes.push(EInfrastructure.FitnessCentre);
  }

  if (hasStudio) {
    infrastructureTypes.push(EInfrastructure.Studio);
  }

  if (hasCentralReception) {
    infrastructureTypes.push(EInfrastructure.CentralReception);
  }

  return nonEmptyArrayOr(infrastructureTypes);
}
